const MODULE_ID = 'AA';

const REQUEST_TYPE = {
  INDIVIDUAL: 'individual',
  COLLECTIVE: 'collective'
};

const CARD_STATUS = {
  APPROVE: 'approve',
  REJECT: 'reject',
};

const MODAL_ACTIONS = {
  SEND: 'send',
  CANCEL: 'cancel',
  REJECT: 'reject',
  APPROVED: 'approve',
  APPROVE_ALL: 'approve_all',
};

const DELEGATION_TYPE = {
  EMPLOYEE: 'R',
  MANAGER: 'A'
};

const MODAL_STATES = {
  managerListConfirmAll: 'managerListConfirmAll',
  isManagerRejecting: 'isManagerRejecting',
  isSendingAllCards: 'isSendingAllCards',
  approve: 'approve',
  rejected: 'reject',
  failed: 'failed',
  isDelegated: 'isDelegated',
  approveReject: 'approveReject',
};

const AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG = {
  module: 'AA',
  tab: 'myFoodBenefit',
  state: 'my-food-benefit',
  title: 'FOOD_BENEFIT.COACHMARK.MY_FOOD_BENEFIT.TITLE',
  subtitles: [
    {
      text: 'FOOD_BENEFIT.COACHMARK.MY_FOOD_BENEFIT.STEP0',
    }, {
      text: 'FOOD_BENEFIT.COACHMARK.MY_FOOD_BENEFIT.STEP1',
    },
  ],
  imgs: [
    {
      source: 'img/welcome-modal/foodBenefit/Mi_Ayuda_Alimentaria_1.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/foodBenefit/Mi_Ayuda_Alimentaria_2.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    },
  ],
};

const AA_MANAGER_MODAL_COACHMARK_CONFIG = {
  module: 'AA',
  tab: 'foodBenefitManager',
  state: 'food-benefit-manager',
  title: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_MANAGER.TITLE',
  subtitles: [
    {
      text: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_MANAGER.STEP0',
    },
  ],
  imgs: [
    {
      source: 'img/welcome-modal/foodBenefit/Solicitudes_Equipo_1.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    },
  ],
};

const AA_WORK_TEAM_MODAL_COACHMARK_CONFIG = {
  module: 'AA',
  tab: 'foodBenefitWorkTeam',
  state: 'food-benefit-work-team',
  title: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_WORK_TEAM.TITLE',
  subtitles: [
    {
      text: 'FOOD_BENEFIT.COACHMARK.FOOD_BENEFIT_WORK_TEAM.STEP0',
    },
  ],
  imgs: [
    {
      source: 'img/welcome-modal/foodBenefit/Work_Team_1.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    },
  ],
};

const AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG = {
  module: 'AA',
  tab: 'delegations',
  state: 'delegations',
  title: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.TITLE',
  subtitles: [
    {
      text: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.STEP0',
    }, {
      text: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.STEP1',
    }, {
      text: 'FOOD_BENEFIT.COACHMARK.DELEGATIONS.STEP2',
    },
  ],
  imgs: [
    {
      source: 'img/welcome-modal/foodBenefit/Delegacion_Permiso_1.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/foodBenefit/Delegacion_Permiso_2.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    }, {
      source: 'img/welcome-modal/foodBenefit/Delegacion_Permiso_3.png',
      alt: 'GLOBALS.COACHMARK.SLIDE_IMG_ALT',
    },
  ],
};

export {
  MODULE_ID,
  REQUEST_TYPE,
  CARD_STATUS,
  DELEGATION_TYPE,
  MODAL_STATES,
  MODAL_ACTIONS,
  AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG,
  AA_MANAGER_MODAL_COACHMARK_CONFIG,
  AA_DELEGATIONS_MANAGER_MODAL_COACHMARK_CONFIG,
  AA_WORK_TEAM_MODAL_COACHMARK_CONFIG
};



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/constants.js